import { StackScreenProps } from "@react-navigation/stack";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { LlmStrategyFormValues } from "../../components/LlmStrategyForm";
import { useFormContext } from "react-hook-form";
import { View } from "react-native";
import { AnthropiciModels } from "./common";
import { Colors } from "react-native-ui-lib";
import { Feather } from "@expo/vector-icons";

export interface SelectAnthropiciModelScreenProps
  extends StackScreenProps<any, "SelectAnthropicModelScreen"> {}

export const SelectAnthropicModelScreen = ({
  navigation,
}: SelectAnthropiciModelScreenProps) => {
  const { t } = useTranslation("settings");
  const { getValues, setValue } = useFormContext<LlmStrategyFormValues>();
  const watchedKeyType = getValues("anthropicConfig.anthropicModel");
  const handleOnSelect = (code: string) => {
    setValue("anthropicConfig.anthropicModel", code, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.goBack();
  };
  return (
    <Page
      title={t("title.select_anthropic_model")}
      secondaryTitle={t("title.select_anthropic_model_secondary")}
    >
      <View>
        <FlatActionList
          items={AnthropiciModels.map((llmType) => ({
            key: llmType.value,
            title: llmType.label,
            subTitle: llmType.description,
            selected: llmType.value === watchedKeyType,
            onPress: () => {
              handleOnSelect(llmType.value);
            },
          }))}
        />
      </View>
    </Page>
  );
};
